var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCross = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.138,
    height: 11.138,
    viewBox: "0 0 11.138 11.138",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.414 1.414)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5634,498.987l8.31,8.31",
    transform: "translate(-5634 -498.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0,8.31,8.31",
    transform: "translate(8.31) rotate(90)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.b8610db5.svg";
export { ForwardRef as ReactComponent };